export class BusinessList {
  Id: number;
  OrganizationNumber: string;
  CompanyNumber: string;
  CompanyName: string;
  Telephone: string;
  Connectedto: string;
  CategoryName: string;
  LicenseMonth: string;
  Status: number;
  CreatedOn: string;
  ModifiedOn: string;
  LoginDate: string;
  LoginCount: number;
  EmployeeCount: number;
  Email: string;
  Address: string;
  Zipcode: string;
  BusinessLogo: string;
  AboutBusiness: string;
  LicenseCategoryId: number;
  PricePerMonth: number;

  // Legacy fields for backward compatibility
  AgreementName?: string;
  Categoty?: string;
  Application?: string;
  Portal?: string;
  CreatedBy?: string;
  ModifiedBy?: string;
  LicenseCategoryName?: string;
  MonthName?: string;
  StatusName?: string;
  IsProject?: string;
  IsFdv?: string;
  IsInternalControl?: string;
  IsFoodSafety?: string;
  IsVehicle?: string;
  IsActivity?: string;
  IsDeviation?: string;
  IsRiskAnalysis?: string;
  OtherSystems?: string;
  QualitySystem?: string;
  Features?: string;
}
export class BusinessAgreement {
  Id: number;
  SalesPerson: string;
  PurchaseDate: string;
  ExpiryDate: string;
  LicenseAggreementId: number;
  LicenseMonth: string;
  Description: string;
  DocumentPath: string;
  Status: string;
  BusinessId: number;
  ApplicationId: number;
  CreatedBy: string;
  CreatedOn: string;
  ModifiedBy: string;
  ModifiedOn: string;
  AgreementName: string;
  LicenseCategoryId?: number;
  PricePerMonth?: number;
  NoOfEmployees: number;
  NoOfUsers: number;
  EmployeeLimit?: number | null;
  IsUnlimitedEmployees?: boolean;
}

export class User {
  Id: number;
  LanguageId: number;
  RoleId: number;
  ApplicationId: number;
  BusinessId: number;
  Rights: string;
  FeatureId: number;
  FeatureKey: String;
  Username: string;
  Password: string;
  Email: string;
  Name: string;
  Avatar: string;
  Sso: string;
  SsoUsername: string;
  SsoDomain: string;
  SsoLoggedIn: string;
  NotificationUpdateOn: string;
  Status: number;
}
